import { render, staticRenderFns } from "./NewsCardView.vue?vue&type=template&id=37e1d850&scoped=true"
import script from "./NewsCardView.vue?vue&type=script&lang=ts"
export * from "./NewsCardView.vue?vue&type=script&lang=ts"
import style0 from "./NewsCardView.vue?vue&type=style&index=0&id=37e1d850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e1d850",
  null
  
)

export default component.exports